export function hasInputValue(value) {
	return value !== null && value !== undefined && value !== ""
}
